<template>
  <div class="flex justify-center items-center w-screen h-screen">
    <div class="-mt-14">
      <div class="text-center text-xl font-normal text-gray-700 pt-8">
        Sincronizando com a cabine
      </div>
      <div class="pa-4">
        <div v-if="contagemError >= 10">
          <div class="text-center text-xl font-normal text-gray-700 pt-8">
            Ocorreu um erro ao sincronizar com a cabine
          </div>
          <div class="text-center text-xl font-normal text-gray-700 pt-8">
            <button
              class="text-white py-3 px-6 rounded-md focus:bg-pink-500 bg-pink-600 hover:bg-pink-500"
              @click="tentarNovamente()"
            >
              Tentar novamente
            </button>
          </div>
        </div>
        <div v-else class="flex justify-center items-center">
          <div
            class="animate-spin rounded-full h-20 w-20 border-0 border-t-2 border-pink-400 mt-10 p-5 border-dotted bg-pink-50"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { autenticarPorCode } from "../service/auth.js";
import { AtivaTotemNoModoUpload, loggerError, db } from "../service/firebase";
import etapa from "@/constants/etapaCompra";

export default {
  data() {
    return {
      contagemError: 0,
    };
  },

  async mounted() {
    const code = this.$route.params.code?.toUpperCase();

    // Sem code na URL → manda digitar manualmente
    if (!code || code.length !== 5) {
      this.$router.push("/code");
      return;
    }

    try {
      // Mesmo fluxo da tela de digitação manual
      const { compra_id } = await autenticarPorCode(code);
      console.log("✅ Auth ok, compra_id:", compra_id); // log temporário
      await this.verificarExistenciaEStatus(compra_id);
    } catch (err) {
      console.error("❌ Erro no mounted:", err); // log temporário
      loggerError(err);

      if (err.status === 404 || err.status === 403) {
        // Code inválido ou já usado → manda digitar manualmente
          this.$router.push("/code"); // Para qualquer erro, sempre redireciona para a tela de informar o código
        } else {
          this.$router.push("/sem-autorizacao");
      }
    }
  },

  methods: {
    async verificarExistenciaEStatus(compra_id) {
      const docSnap = await db.collection("compras").doc(compra_id).get();

      if (!docSnap.exists) {
        loggerError("compra nao existe");
          this.$router.push("/code");
          return; // Redireciona para a tela de informar o código
      }

      const statusEtapa = docSnap.data().etapa;
      await this.verificaEtapa(statusEtapa, compra_id, docSnap);
    },

    async verificaEtapa(etapaPayload, compra_id, docSnap) {
      if (etapaPayload === etapa.SCAN_QR_CODE) {
        localStorage.setItem("compra_id", compra_id);
        this.$store.commit("compra/setCompra", docSnap.data());
        this.ativacaoTotem();
      } else {
        loggerError("compra nao esta em SCAN");
          this.$router.push("/code");
      }
    },

    tentarNovamente() {
      this.contagemError = 0;
      const compra_id = localStorage.getItem("compra_id");
      if (compra_id) this.ativacaoTotem();
    },

    ativacaoTotem() {
      AtivaTotemNoModoUpload()
        .then(() => {
          this.$router.push("/user/seleciona-metodo");
        })
        .catch((error) => {
          this.contagemError++;
          if (this.contagemError >= 10) {
            loggerError(error);
            return;
          }
          setTimeout(() => this.ativacaoTotem(), 500);
        });
    },
  },
};
</script>

<style></style>
